import { apiService } from "./../../app.service";

export const allergyApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchAllergy: builder.query({
      query: () => ({
        url: "/user/dish",
      }),
    }),
    fetchAllergyBySearch: builder.mutation({
      query: (params) => ({
        url: "/user/dish/search",
        method: "POST",
        body: params,
      }),
    }),
    createAllergy: builder.mutation({
      query: (data) => ({
        url: "/user/dish",
        method: "POST",
        body: data,
      }),
    }),
    fetchAllergyById: builder.query({
      query: (id) => ({
        url: `/user/dish/${id}`,
      }),
    }),
    updateAllergy: builder.mutation({
      query: (param) => ({
        url: `/user/dish/${param.id}`,
        method: "PATCH",
        body: param.data,
      }),
    }),
    deleteAllergy: builder.mutation({
      query: (id) => ({
        url: `/user/dish/${id}`,
        method: "DELETE",
      }),
    }),
    
    fetchAllergyChart: builder.query({
      query: () => ({
        url: "/user/allergy-chart",
        responseHandler: async (response) => {
          const blob = await response.blob();
          return URL.createObjectURL(blob);
        },
      }),
    }),

    uploadAllergyChart: builder.mutation({
      query: (pdfFile) => {
        const formData = new FormData();
        formData.append("file", pdfFile); // Adjust key name to match backend expectations
        return {
          url: "/user/upload/allergy-chart",
          method: "POST",
          body: formData,
        };
      },
    }),
  }),
});

export const {
  useFetchAllergyQuery,
  useFetchAllergyBySearchMutation,
  useCreateAllergyMutation,
  useFetchAllergyByIdQuery,
  useUpdateAllergyMutation,
  useDeleteAllergyMutation,
  useFetchAllergyChartQuery,
  useUploadAllergyChartMutation,
} = allergyApi;
